const objectFitImages = require('object-fit-images');
import 'lazysizes';

import Story from './components/Story';
import Videos from './components/Videos';
import Menu from './components/Menu';
import Episode from './components/Episode';
import CookieBar from './components/CookieBar';
import Video from './components/Video';

class Resilience {
	constructor() {
		Promise.all([Resilience.domReady()]).then(() => this.init());
	}

	init() {
		this.createStory();
		this.createEpisode();
		this.createMenu();
		new Videos();
		new Video();
		this.cookieBar = new CookieBar();

		const blessEvent = new CustomEvent('bless');
		document.dispatchEvent(blessEvent);
	}

	createStory() {
		const story = document.querySelector('.single-story');

		if (!story) {
			return;
		}

		this.story = new Story(story);
		this.story.init();
	}

	createEpisode() {
		const episode = document.querySelector('.single-episode');

		if (!episode) {
			return;
		}

		this.episode = new Episode(episode);
		this.episode.init();
	}

	createMenu() {
		const header = document.querySelector('.c-header');

		if (!header) {
			return;
		}

		this.menu = new Menu(header);
		this.menu.init();
	}

	static domReady() {
		return new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Resilience();
